<div class="the-woods-container">
  <div class="color-strip-area" [style.width]="viewModel.colorStripWidth$ | push: 'immediate'">
    <div class="the-woods-strain-type">{{ viewModel.strainText$ | push: 'immediate' }}</div>
  </div>
  <div class="the-woods-content-area">
    <div class="top-half-of-card-with-images">
      <ng-container *rxLet="data | getVariantAssetForCard | push: 'immediate' as brandAsset">
        <ng-container *rxIf="brandAsset; strategy: 'immediate'; else: noBrandLogo">
          <img
            appImage
            class="brand-logo"
            [asset]="data | getVariantAssetForCard | push: 'immediate'"
            src=""
            alt="brand logo" />
        </ng-container>
        <ng-template #noBrandLogo><div class="no-brand-logo">no brand logo</div></ng-template>
      </ng-container>
      <div class="company-logo-and-craft">
        <ng-container
          *rxLet="
            ((data?.menu | productMenuBasicMethod: 'showCompanyLogo') && data?.menu?.companyLogo) ||
              (viewModel.hasCraftDesignation$ | push: 'immediate') as hasContent;
            strategy: 'immediate'
          ">
          <img
            *rxIf="data?.menu | productMenuBasicMethod: 'showCompanyLogo'"
            appImage
            class="company-logo"
            [asset]="data?.menu?.companyLogo"
            src=""
            alt="company logo" />
          <img
            *rxIf="viewModel.hasCraftDesignation$ | push: 'immediate'"
            appImage
            [localAsset]="'assets/images/the-woods-cannabis/ocs_craft_badge.png'"
            class="craft-badge"
            alt="craft badge"
            src="" />
          <!-- so the flex container has something to render, and doesn't mess up when generating pdf -->
          <div *rxIf="!hasContent; strategy: 'immediate'" class="no-company-logo-or-craft-badge">nothing</div>
        </ng-container>
      </div>
    </div>
    <div class="product-name-and-lineage">
      <div
        appPrintCardScaleDownText
        [transparentWhileScaling]="viewModel.viewingInLiveView$ | async"
        [maxHeightInPx]="30"
        [maxWidthInPx]="352"
        class="product-name">
        {{ data | sectionRowViewModelBasicMethod: 'getRowTitle' | trimSafely | orSpaceCharacter }}
      </div>
      <div
        appPrintCardScaleDownText
        [transparentWhileScaling]="viewModel.viewingInLiveView$ | async"
        [maxHeightInPx]="20"
        [maxWidthInPx]="352"
        class="lineage-name">
        {{ viewModel.lineage$ | push: 'immediate' | trimSafely | fallback: 'Unspecified Genetics' }}
      </div>
    </div>
    <div class="content-divider" [style.background-color]="viewModel.strainTypeColor$ | push: 'immediate'"></div>
    <div class="product-details">
      <div class="product-badges">
        <img
          *rxFor="let badgeUrl of viewModel.badgeUrls$; strategy: 'immediate'; trackBy: viewModel.trackByUrl"
          appImage
          class="the-woods-badge"
          alt="badge"
          [localAsset]="badgeUrl"
          src="" />
      </div>
      <div class="product-information">
        <app-the-woods-properties-section
          [propertiesBasedOnPools]="viewModel.customPropertiesBasedOnPools$ | push: 'immediate'"
          [viewingInLiveView]="viewModel.viewingInLiveView$ | push: 'immediate'" />
        <app-the-woods-product-info-section
          [title]="'Dominant Terpenes'"
          [productInfo]="viewModel.presentTerpenes$ | push: 'immediate' | fallback: 'Terpenes not specified.'" />
        <app-the-woods-product-info-section
          [title]="'Associated Effects'"
          [productInfo]="viewModel.associatedDelimitedEffects$ | push: 'immediate' | fallback: 'Effects may vary.'" />
        <app-the-woods-product-info-section
          [title]="'Description'"
          [productInfo]="viewModel.shortDescription$ | push: 'immediate'"
          [productInfoClampTo]="5" />
      </div>
    </div>
    <div class="price-section">
      <ng-container
        *rxLet="
          viewModel | getExpandedGridSize: (viewModel.spoofedColViewModel$ | async) : false : true : false as size;
          strategy: 'immediate'
        ">
        <app-column-primary-price
          [menu]="viewModel.cardStackMenu$ | async"
          [section]="viewModel.cardStack$ | async"
          [colVm]="viewModel.spoofedColViewModel$ | async"
          [rowVm]="viewModel.cardData$ | async"
          [locConfig]="viewModel.locationConfig$ | async"
          [locationId]="viewModel.locationId$ | async"
          [leadingTextOriginalPriceWithoutSale]="size ? '/' + size : null"
          [leadingTextSalePrice]="size ? '/' + size : null"
          [includeLineThroughOnLeadingTextOriginalPriceWithSale]="false"
          [forceNgContentToBeShownWithinPreviousPriceContainer]="true"
          [productStylingVm]="viewModel">
          <app-label-inflator
            *rxIf="viewModel.atLeastOneGridVariantOnSale$; strategy: 'immediate'"
            class="the-woods-label-inflator"
            [columnLabel]="false"
            [labelComponentInterface]="data"
            [reset]="false">
          </app-label-inflator>
        </app-column-primary-price>
        <app-label-inflator
          *rxIf="viewModel.showLabelBelowPrice$; strategy: 'immediate'"
          class="the-woods-label-inflator"
          [columnLabel]="false"
          [labelComponentInterface]="data"
          [reset]="false">
        </app-label-inflator>
      </ng-container>
    </div>
  </div>
</div>
